import { OktaAuth} from '@okta/okta-auth-js';

export const isLocalhost = window.location.href.startsWith("http://localhost");
export const bearer = "Bearer "

export let accessToken : string | undefined;

const ACCESS_TOKEN = 'accessToken';
const ID_TOKEN = 'idToken';

export const setAccessToken = (token: string | undefined) => {
  accessToken = token;
};

let idToken : string | undefined;
export const setIdToken = (token: any) => {
  idToken = token;
};

export let accessTokenExpiry: number;
export const setAccessTokenExpiry = (tokenExpiry: number = 0) => {
  accessTokenExpiry = tokenExpiry;
};

export let userSessionExpiry: number;
export const setUserSessionExpiry = (sessionExpiry: number = 0) => {
  userSessionExpiry = sessionExpiry;
};

export const getOktaSettings = () => {
    const oktaSettings = JSON.parse(import.meta.env.VITE_OKTA_SETTINGS);
    return oktaSettings;
};

let oktaSettings = getOktaSettings()
export const oktaAuth = new OktaAuth({
  issuer: oktaSettings.issuer,
  clientId: oktaSettings.clientId,
  redirectUri: oktaSettings.redirectUri,
  scopes: oktaSettings.scopes,
  responseType : oktaSettings.responseType,
  pkce : true,
  tokenManager : {
    autoRenew : true,
    autoRemove : true
  }
});

oktaAuth.tokenManager.on('renewed', (key, newToken) => {
  if (newToken && ACCESS_TOKEN in newToken) {
    setAccessTokenExpiry(newToken?.expiresAt);
    oktaAuth.tokenManager.add(
      "accessToken",
      newToken
    );
    setAccessToken(newToken["accessToken"])
    if (newToken?.claims?.auth_time) {
      const oktaSettings = getOktaSettings()
      const userSessionExpiry = newToken.claims.auth_time + Number(oktaSettings.sessionExpiresIn)
      setUserSessionExpiry(userSessionExpiry)
    }
  }
  if (newToken && ID_TOKEN in newToken) {
    oktaAuth.tokenManager.add(
      "idToken",
      newToken
    );
    setIdToken(newToken?.idToken)
  }
});

oktaAuth.tokenManager.on('error', (err) => {
  console.error('Token renewal error:', err);
  oktaAuth.signInWithRedirect()
});

export const checkAndRenewTokens = (oktaAuth : OktaAuth , userSessionExpiry : number , accessTokenExpiry : number, onError?: any) =>{
    const currentTime = Math.floor(Date.now() / 1000);
    if (!isLocalhost && userSessionExpiry && currentTime >= userSessionExpiry) {
      oktaAuth.signInWithRedirect()
    }
    if (!isLocalhost && accessTokenExpiry && currentTime >= accessTokenExpiry) {
      Promise.all([
        oktaAuth.tokenManager.renew(ACCESS_TOKEN),
        oktaAuth.tokenManager.renew(ID_TOKEN)
      ]).then(([renewedAccessToken, renewedIdToken]) => {
        if (renewedAccessToken && ACCESS_TOKEN in renewedAccessToken) {
          oktaAuth.tokenManager.add(
            ACCESS_TOKEN,
            renewedAccessToken
          );
          const accessToken = renewedAccessToken.accessToken;
          setAccessToken(accessToken);
          setAccessTokenExpiry(renewedAccessToken.expiresAt)
        } else {
          console.error('Failed to renew access token');
        }
        if (renewedIdToken && ID_TOKEN in renewedIdToken) {
          oktaAuth.tokenManager.add(
            ID_TOKEN,
            renewedIdToken
          );
          const idToken = renewedIdToken.idToken;
          console.log('Renewed ID Token:', idToken);
          setIdToken(idToken); 
        } else {
          console.error('Failed to renew ID token');
        }
      }).catch((error) => {
        if (onError) {
          onError(error);
        }
        throw error;
      });
    }
}

export const getAccessTokenDetails = () => {
  const accessTokenDetails= {
    "accessToken" : accessToken,
    "userSessionExpiry" : userSessionExpiry,
    "accessTokenExpiry" : accessTokenExpiry,
  }
  return accessTokenDetails
};

export function handleAuthError(error: any) {
  if (error.errorCode === 'AuthSdkError') {
    if (error.errorSummary.includes('PKCE')) {
      console.error('PKCE codeVerifier error detected. Reloading page.');
      const originalUrl = window.location.href.split("?")[0];
      window.history.replaceState({}, document.title, originalUrl);
      window.location.reload();
    }
  } else {
    console.error('Unhandled authentication error:', error);
  }
}